import {createSelector} from '@ngrx/store';

import {TAXES_FEATURE_KEY, selectMasterDataModuleState} from '../reducers';

export const selectTaxesState = createSelector(
  selectMasterDataModuleState,
  (moduleState) => moduleState[TAXES_FEATURE_KEY]
);

export const selectTaxesEntities = createSelector(
  selectTaxesState,
  (state) => state.entities
);

export const selectTaxes = createSelector(
  selectTaxesEntities,
  (entities) => Object.values(entities)
);

export const selectErrors = createSelector(
  selectTaxesState,
  (state) => state.errors
);

export const isLoading = createSelector(
  selectTaxesState,
  (state) => state.loading
);

export const isLoaded = createSelector(
  selectTaxesState,
  (state) => state.loaded
);
